var _path, _path2, _path3, _g, _path4, _g2, _path5, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 48,
    viewBox: "0 0 66 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.7372 20.4531C33.7372 21.7406 33.2825 22.8089 32.3728 23.6589C31.463 24.5096 30.3354 24.9354 28.9925 24.9354C27.6057 24.9354 26.4688 24.5096 25.581 23.6589C24.6923 22.8089 24.249 21.7406 24.249 20.4531C24.249 19.1685 24.6923 18.0876 25.581 17.2162C26.4688 16.3452 27.6057 15.9102 28.9925 15.9102C30.3354 15.9102 31.463 16.3452 32.3728 17.2162C33.2825 18.0876 33.7372 19.1685 33.7372 20.4531Z",
    fill: "#5650F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.789 47.7261C34.4627 47.9081 33.347 47.9998 31.44 47.9998C29.2539 47.9998 27.684 47.5441 26.7315 46.6358C25.7775 45.7276 25.3008 44.2954 25.3008 42.3407V30.2211C25.4408 30.1768 25.8595 30.1193 26.5565 30.0511C27.2544 29.9833 27.9047 29.9492 28.5106 29.9492C32.6957 29.9492 34.789 31.7454 34.789 35.3341V47.7261Z",
    fill: "#0F1419"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2506_595",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 0,
    width: 10,
    height: 48
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4976 0H50.5273V47.9995H41.4976V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2506_595)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5273 47.7315C50.1288 47.9097 49.0226 47.9995 47.2077 47.9995C43.4004 47.9995 41.4976 46.1526 41.4976 42.4579V0.267994C41.6308 0.223328 42.0293 0.16652 42.6926 0.100172C43.3568 0.0333908 43.9757 0 44.5523 0C48.5352 0 50.5273 1.75887 50.5273 5.27488V47.7315Z",
    fill: "#0F1419"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2506_595",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 7,
    width: 20,
    height: 41
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.0332H19.8995V47.9992H0V7.0332Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2506_595)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3464 7.0332C12.7143 7.0332 12.0356 7.06688 11.3071 7.13424C10.5794 7.20116 10.1425 7.25802 9.99668 7.30351V16.9236H6.04459C2.01471 16.9236 0 18.8534 0 22.7147C0 24.5552 0.0982898 25.6776 0.29254 26.0813H9.99668V42.4097C9.99668 46.1359 12.0831 47.9992 16.2588 47.9992C18.2488 47.9992 19.4628 47.9086 19.8997 47.7289V12.3537C19.8997 8.80728 17.715 7.0332 13.3464 7.0332Z",
    fill: "#0F1419"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2506_595",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 56,
    y: 0,
    width: 10,
    height: 48
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9692 0H65.999V47.9995H56.9692V0Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2506_595)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.999 47.7315C65.6005 47.9097 64.4942 47.9995 62.6794 47.9995C58.8721 47.9995 56.9692 46.1526 56.9692 42.4579V0.267994C57.1025 0.223328 57.501 0.16652 58.1643 0.100172C58.8285 0.0333908 59.4474 0 60.024 0C64.0069 0 65.999 1.75887 65.999 5.27488V47.7315Z",
    fill: "#0F1419"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4f98930fe452e91b83a6bdfabef28451.svg";
export { ForwardRef as ReactComponent };